import React, { useEffect, useMemo, useState } from "react";
import "./Demo.css";
import { Fetch } from "../../shared/Fetch";
import DailyPOTracker from "./DailyPOTracker";

type Branch = {
    id: number;
    name: string;
    sept: number;
    min: number;
    max: number;
    todayAchieved: number;
    color: string;
};

// const branches: Branch[] = [
//     { id: 0, name: "Agra", sept: 46, min: 129, max: 166, todayAchieved: 0, color: "#61D1FF" },
//     { id: 1, name: "Varanasi", sept: 23, min: 60, max: 81, todayAchieved: 0, color: "#C4FF67" },
//     { id: 2, name: "Noida", sept: 22, min: 73, max: 103, todayAchieved: 0, color: "#FFB86C" },
//     { id: 3, name: "Bhubaneswar", sept: 11, min: 25, max: 32, todayAchieved: 0, color: "#86A8FF" },
//     { id: 4, name: "Ranchi", sept: 6, min: 11, max: 15, todayAchieved: 0, color: "#FF8C82" },
//     { id: 5, name: "Meerut", sept: 5, min: 10, max: 13, todayAchieved: 0, color: "#FF83B5" },
//     { id: 6, name: "Lucknow", sept: 1, min: 10, max: 15, todayAchieved: 0, color: "#B89AFF" },
// ];

// Thanksgiving holidays
const holidays = [
    `${2026}-11-26`,
    `${2026}-11-27`
];

const isWorkingDay = (date: Date) => {
    const day = date.getDay();

    const dateString = [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, "0"),
        String(date.getDate()).padStart(2, "0")
    ].join("-");

    return (
        day !== 0 &&
        day !== 6 &&
        !holidays.includes(dateString)
    );
};

const currentDate = new Date();
const endDate = new Date(currentDate.getFullYear(), 10, 31);

let working_DAYS = 0;

const date = new Date(currentDate);
date.setHours(0, 0, 0, 0);

while (date < endDate) {
    const day = date.getDay();

    // 0 = Sunday, 6 = Saturday
    if (isWorkingDay(date)) {
        working_DAYS++;
    }

    date.setDate(date.getDate() + 1);
}

const WORKING_DAYS = working_DAYS;

const fmt = (n: number) => Math.round(n).toLocaleString("en-IN");

const pct = (value: number, total: number) => total > 0 ? (value / total) * 100 : 0;

// const renderPlanTable = (days: any) => (
//     <div className="plan-table-wrap">
//         <table className="plan-table">
//             <thead>
//                 <tr>
//                     <th>#</th>
//                     <th>WORKING DAY</th>
//                     <th>DAILY TARGET</th>
//                     <th>CUMULATIVE TARGET</th>
//                     <th>MIN GAP LEFT</th>
//                     <th>STATUS</th>
//                 </tr>
//             </thead>

//             <tbody>
//                 {days.map((day: any) => (
//                     <tr key={day.day}>
//                         <td>{day.day}</td>
//                         <td>{day.date}</td>

//                         <td className="lime">
//                             {fmt(day.target)} POs
//                         </td>

//                         <td>
//                             {fmt(day.cumulative)} POs
//                         </td>

//                         <td>
//                             {fmt(day.remainingAfterPlan)} POs
//                         </td>

//                         <td>
//                             <span className="status-pill">PLANNED</span>
//                         </td>
//                     </tr>
//                 ))}
//             </tbody>
//         </table>
//     </div>
// );

function Demo_s() {
    const [branches, setBranches] = useState<Array<Branch>>([{ id: 0, name: "", sept: 0, min: 0, max: 0, todayAchieved: 0, color: "#61D1FF" }]);
    const [targetMode, setTargetMode] = useState<"min" | "max">("min");
    const [showPlan, setShowPlan] = useState(true);

    const loadCurretScore = async () => {
        const response1 = await Fetch("Requirement_MAST/octTargetBranch", "GET", null, null, null);
        if (response1) {
            const data: Branch[] = await response1.json();
            setBranches(data);
        }
    }

    // Select the best-performing branch by default.
    const bestBranch = [...branches].sort(
        (a, b) => pct(b.sept, b.min) - pct(a.sept, a.min)
    )[0];

    const [selectedBranchName, setSelectedBranchName] = useState(
        "All"
    );

    const isAllSelected = selectedBranchName === "All";

    const selectedBranch = branches.find(
        (branch) => branch.name === selectedBranchName
    );

    const branchAchieved = isAllSelected
        ? branches.reduce((sum, branch) => sum + branch.sept, 0)
        : selectedBranch?.sept ?? 0;

    const branchMinimum = isAllSelected
        ? branches.reduce((sum, branch) => sum + branch.min, 0)
        : selectedBranch?.min ?? 0;

    const branchRemaining = Math.max(
        branchMinimum - branchAchieved,
        0
    );

    const displayedBranchName = isAllSelected
        ? "All Branches"
        : selectedBranch?.name ?? "All Branches";

    const displayedBranchColor = isAllSelected
        ? "#C4FF67"
        : selectedBranch?.color ?? "#C4FF67";

    const branchDailyPace = Math.ceil(branchRemaining / WORKING_DAYS);

    const stats = useMemo(() => {
        const achieved = branches.reduce((s, b) => s + b.sept, 0);
        // const minimum = branches.reduce((s, b) => s + b.min, 0);
        const minimum = 251;
        const maximum = branches.reduce((s, b) => s + b.max, 0);
        const today = branches.reduce((s, b) => s + b.todayAchieved, 0);
        const remaining = Math.max(minimum - achieved, 0);
        const dailyPace = Math.ceil(remaining / WORKING_DAYS);

        return {
            achieved,
            minimum,
            maximum,
            today,
            remaining,
            dailyPace,
            achievementPercent: pct(achieved, minimum),
        };
    }, [branches]);

    const sortedBranches = useMemo(
        () =>
            [...branches].sort(
                (a, b) => pct(b.sept, b.min) - pct(a.sept, a.min)
            ),
        [branches]
    );

    // const dailyPlan = useMemo(() => {
    //     const base = Math.floor(stats.remaining / WORKING_DAYS);
    //     const extra = stats.remaining % WORKING_DAYS;

    //     return Array.from({ length: WORKING_DAYS }, (_, i) => {
    //         const target = base + (i < extra ? 1 : 0);
    //         const cumulative = Math.min(
    //             stats.remaining,
    //             base * (i + 1) + Math.min(i + 1, extra)
    //         );

    //         const date = new Date(2026, 9, 19);
    //         date.setDate(date.getDate() + i);

    //         return {
    //             day: i + 1,
    //             target,
    //             cumulative,
    //             date: date.toLocaleDateString("en-GB", {
    //                 weekday: "short",
    //                 day: "2-digit",
    //                 month: "short",
    //             }),
    //         };
    //     });
    // }, [stats.remaining]);

    const dailyPlan = useMemo(() => {
        // const remaining = Math.max(
        //     selectedBranch.min - selectedBranch.sept,
        //     0
        // );
        const remaining = branchRemaining;

        // Allocate whole POs evenly across the working days.
        const base = Math.floor(remaining / WORKING_DAYS);
        const extra = remaining % WORKING_DAYS;

        let cumulativeAllocated = 0;

        return Array.from({ length: WORKING_DAYS }, (_, i) => {
            const target = base + (i < extra ? 1 : 0);

            cumulativeAllocated += target;

            // Skip Saturdays and Sundays.
            const date = new Date(2026, 10, 2);
            let workingDaysAdded = 0;

            while (workingDaysAdded < i) {
                date.setDate(date.getDate() + 1);

                if (date.getDay() !== 0 && date.getDay() !== 6) {
                    workingDaysAdded++;
                }
            }

            return {
                day: i + 1,
                target,
                // cumulative: selectedBranch.sept + cumulativeAllocated,
                cumulative: branchAchieved + cumulativeAllocated,
                remainingAfterPlan: Math.max(
                    remaining - cumulativeAllocated,
                    0
                ),
                date: date.toLocaleDateString("en-GB", {
                    weekday: "short",
                    day: "2-digit",
                    month: "short",
                }),
            };
        });
        // }, [selectedBranch]);
    }, [branchRemaining, branchAchieved]);

    // const selectedTarget = targetMode === "min" ? stats.minimum : stats.maximum;
    const selectedTarget = 251;

    const renderPlanTable = (days: typeof dailyPlan) => (
        <div className="plan-table-wrap">
            <table className="plan-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>WORKING DAY</th>
                        <th>DAILY TARGET</th>
                        <th>CUMULATIVE</th>
                        <th>MIN GAP LEFT</th>
                        <th>STATUS</th>
                    </tr>
                </thead>
                <tbody>
                    {days.map((day) => (
                        <tr key={day.day}>
                            <td>{day.day}</td>
                            <td>{day.date}</td>
                            <td className="lime">{fmt(day.target)} POs</td>
                            <td>{fmt(day.cumulative)} POs</td>
                            {/* <td>{fmt(stats.remaining - day.cumulative)} POs</td> */}
                            <td>{fmt(day.remainingAfterPlan)} POs</td>
                            <td>
                                <span className="status-pill">PLANNED</span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    useEffect(() => {
        loadCurretScore();
    }, []);

    return (
        <main className="dashboard_Oct">
            <header className="topbar">
                <div className="brand">
                    <span className="brand-mark">ϟ</span>
                    <strong>MISSION</strong>
                    <span className="brand-divider" />
                    <span className="brand-subtitle">🔥 <span style={{ color: "" }}>THIRD</span> <span style={{ color: "#c4ff67", fontSize: "17px" }}>ATTEMPT</span> <span style={{ color: "orange" }}>◆</span> <span style={{ color: "" }}>FULL</span> <span style={{ color: "#c4ff67", fontSize: "17px" }}>POWER</span> <span style={{ color: "orange" }}>◆</span> <span style={{ color: "" }}>DEFINITE</span> <span style={{ color: "#c4ff67", fontSize: "17px" }}>VICTORY!</span> 🔥</span>
                </div>
                <div className="topbar-right">
                    <span className="date-pill">▦ &nbsp; NOV 2026</span>
                    <span className="avatar">▦</span>
                </div>
            </header>

            <section className="hero-grid">
                <article className="panel hero-card">
                    <div className="hero-copy">
                        <span className="eyebrow">THE NOVEMBER TAKEOVER 🚀</span>
                        <h1>
                            {/* {branches.length} Branches. */}
                            3rd Attempt.
                            <br />
                            <span className="lime">One Big Victory.</span>
                        </h1>
                        <p className="metric-label">TOTAL PO ACHIEVEMENT</p>
                        <div className="hero-number">
                            {fmt(stats.achieved)}
                            <span> / {fmt(selectedTarget)}</span>
                        </div>
                        <div className="progress-track hero-progress">
                            <div
                                className="progress-fill lime-fill"
                                style={{
                                    width: `${Math.min(
                                        pct(stats.achieved, selectedTarget),
                                        100
                                    )}%`,
                                }}
                            />
                        </div>
                        <div className="hero-footer">
                            <span>{fmt(stats.remaining)} POs to minimum</span>
                            <span>{stats.achievementPercent.toFixed(1)}%</span>
                        </div>
                    </div>

                    <div className="hero-art">
                        <div className="hero-slogan">
                            Stronger
                            <br /> Than
                            <br /> Before.
                            <br />
                            <span>United for Victory.</span>
                        </div>
                        <div className="mountain mountain-back" />
                        <div className="mountain mountain-middle" />
                        <div className="mountain mountain-front" />
                        <span className="summit-flag">⚑</span>
                    </div>
                </article>

                <article className="panel kpi-card pace-card">
                    <div className="kpi-top">
                        <span className="kpi-icon">◉</span>
                        <span>↗</span>
                    </div>
                    <p className="kpi-label">DAILY PACE NEEDED</p>
                    <div className="kpi-number lime">{fmt(stats.dailyPace)}</div>
                    <p className="kpi-caption">POs / working day</p>
                </article>

                <article className="panel kpi-card time-card">
                    <div className="kpi-top">
                        <span className="kpi-icon purple">▦</span>
                        <span>↗</span>
                    </div>
                    <p className="kpi-label">TIME LEFT</p>
                    <div className="kpi-number">{WORKING_DAYS} days</div>
                    <p className="kpi-caption">Weekends excluded</p>
                </article>
            </section>

            <section className="middle-grid">
                <article className="panel rankings-panel">
                    <div className="section-heading">
                        <div className="section-title">
                            <span className="heading-icon">▥</span>
                            <h2>Branch Power Rankings</h2>
                        </div>
                        <div className="target-toggle">
                            <button
                                className={targetMode === "min" ? "active" : ""}
                                onClick={() => setTargetMode("min")}
                            >
                                MIN TARGET
                            </button>
                            <button
                                className={targetMode === "max" ? "active" : ""}
                                onClick={() => setTargetMode("max")}
                            >
                                MAX TARGET
                            </button>
                        </div>
                    </div>

                    <div className="branch-list">
                        {sortedBranches.map((branch, index) => {
                            const target =
                                targetMode === "min" ? branch.min : branch.max;
                            const progress = pct(branch.sept, target);

                            return (
                                <div className="branch-row" key={branch.name}>
                                    <span className="branch-rank">
                                        {String(index + 1).padStart(2, "0")}
                                    </span>
                                    <span
                                        className="branch-avatar"
                                        style={{
                                            color: branch.color,
                                            background: `${branch.color}20`,
                                        }}
                                    >
                                        {branch.name.slice(0, 2).toUpperCase()}
                                    </span>
                                    <span className="branch-name">{branch.name}</span>
                                    <div className="progress-track branch-track">
                                        <div
                                            className="progress-fill"
                                            style={{
                                                width: `${Math.min(progress, 100)}%`,
                                                background: branch.color,
                                            }}
                                        />
                                    </div>
                                    <span
                                        className="branch-percent"
                                        style={{ color: branch.color }}
                                    >
                                        {Math.round(progress)}%
                                    </span>
                                    <span className="branch-values">
                                        {branch.sept} / {target}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                    <p className="panel-note">
                        ⓘ Progress measured against {targetMode === "min" ? "minimum" : "maximum"} targets.
                    </p>
                </article>

                <div className="mission-column">
                    <article className="panel mission-panel">
                        <div className="mission-heading">
                            <div className="section-title">
                                <span className="mission-icon">◎</span>
                                <div>
                                    <h2>TODAY'S TEAM MISSION</h2>
                                    <p style={{ fontSize: "8px", color: "#9b9c9b" }}>One Shared Goal. All Branches. One Team.</p>
                                    <p className="subheading">{new Date().toLocaleDateString("en-GB", {
                                        weekday: "long",
                                        day: "2-digit",
                                        month: "long",
                                        year: "numeric",
                                    })}</p>
                                </div>
                            </div>
                            <span className="live-pill">● IN PLAY</span>
                        </div>

                        <div className="mission-stats">
                            <div>
                                <p className="metric-label">COLLECTIVE DAILY TARGET</p>
                                <p style={{ fontSize: "7px", color: "#c4ff67" }}>Combined Target Across All Branches</p>
                                <div className="mission-number">
                                    {fmt(stats.dailyPace)} <span>POs</span>
                                </div>
                            </div>
                            <div className="mission-achieved">
                                <p className="metric-label">TOTAL ACHIEVED TODAY</p>
                                <p style={{ fontSize: "7px", color: "#c4ff67" }}>Combined Achievement Across All Branches</p>
                                <div className="mission-number lime">
                                    {fmt(stats.today)} <span>POs</span>
                                </div>
                            </div>
                        </div>

                        <p style={{ fontSize: "7px", marginTop: "7px", marginBottom: "-5px" }}>Team progress</p>
                        <div className="mission-progress-row">
                            <div className="progress-track mission-track">
                                <div
                                    className="progress-fill lime-fill"
                                    style={{
                                        width: `${Math.min(
                                            pct(stats.today, stats.dailyPace),
                                            100
                                        )}%`,
                                    }}
                                />
                            </div>
                            <span>
                                {pct(stats.today, stats.dailyPace).toFixed(1)}%
                            </span>
                        </div>
                        <p className="mission-footer">
                            🚀 {fmt(Math.max(stats.dailyPace - stats.today, 0))} more POs to hit our shared daily target!
                        </p>
                    </article>

                    <div className="mini-stats-grid">
                        <article className="panel mini-card">
                            <span className="mini-icon">◎</span>
                            <p className="mini-label">REMAINING (MIN)</p>
                            <div className="mini-value lime">
                                {fmt(stats.remaining)} <span>POs</span>
                            </div>
                        </article>
                        <article className="panel mini-card">
                            <span className="mini-icon purple">▦</span>
                            <p className="mini-label">WORKING DAYS LEFT</p>
                            <div className="mini-value">{WORKING_DAYS} days</div>
                            <p className="mini-caption">Nov 2 – Nov 30</p>
                        </article>
                        <article className="panel mini-card">
                            <span className="mini-icon violet">ϟ</span>
                            <p className="mini-label">DAILY PACE (REMAINING)</p>
                            <div className="mini-value">
                                {fmt(stats.dailyPace)} POs/day
                            </div>
                        </article>
                    </div>
                </div>
            </section>

            {/* <section className="panel plan-panel">
                <div className="plan-heading">
                    <div className="section-title">
                        <span className="heading-icon">▤</span>
                        <div>
                            <h2>Daily PO Game Plan</h2>
                            <p className="plan-subtitle">
                                {fmt(stats.remaining)} POs remaining &nbsp; • &nbsp;
                                {WORKING_DAYS} working days &nbsp; • &nbsp;
                                Exact allocation, weekends excluded
                            </p>
                        </div>
                    </div>
                    <button
                        className="outline-button"
                        onClick={() => setShowPlan((value) => !value)}
                    >
                        {showPlan ? "Hide Plan −" : "Show Plan +"}
                    </button>
                </div>

                {showPlan && (
                    <div className="plan-columns">
                        {renderPlanTable(dailyPlan.slice(0, 5))}
                        {renderPlanTable(dailyPlan.slice(5, 10))}
                    </div>
                )}
            </section> */}
            <DailyPOTracker apiUrl={"Requirement_MAST/dayWiseTarget"} />
            <section className="panel plan-panel">
                <div className="plan-heading">
                    <div className="section-title">
                        <span className="heading-icon">▤</span>

                        <div>
                            <h2>Daily PO Game Plan</h2>

                            <p className="plan-subtitle">
                                {displayedBranchName} &nbsp; • &nbsp;
                                {fmt(branchAchieved)} achieved
                                &nbsp; / &nbsp;
                                {fmt(branchMinimum)} minimum target
                                &nbsp; • &nbsp;
                                {fmt(branchRemaining)} POs remaining
                                &nbsp; • &nbsp;
                                {WORKING_DAYS} working days
                            </p>
                        </div>
                    </div>

                    <div className="plan-controls">
                        <div className="branch-selector">
                            <button
                                key="All"
                                type="button"
                                className={`branch-tag ${isAllSelected ? "selected" : ""
                                    }`}
                                onClick={() => setSelectedBranchName("All")}
                                aria-pressed={isAllSelected}
                                style={
                                    {
                                        "--branch-color": "#C4FF67",
                                    } as React.CSSProperties
                                }
                            >
                                All
                                {isAllSelected && (
                                    <span className="branch-check">✓</span>
                                )}
                            </button>

                            {branches.map((branch) => {
                                const isSelected = selectedBranchName === branch.name;

                                return (
                                    <button
                                        key={branch.name}
                                        type="button"
                                        className={`branch-tag ${isSelected ? "selected" : ""
                                            }`}
                                        onClick={() => setSelectedBranchName(branch.name)}
                                        aria-pressed={isSelected}
                                        style={
                                            {
                                                "--branch-color": branch.color,
                                            } as React.CSSProperties
                                        }
                                    >
                                        {branch.name}
                                        {isSelected && (
                                            <span className="branch-check">✓</span>
                                        )}
                                    </button>
                                );
                            })}
                        </div>

                        <button
                            className="outline-button"
                            onClick={() => setShowPlan((value) => !value)}
                        >
                            {showPlan ? "Hide Plan −" : "Show Plan +"}
                        </button>
                    </div>
                </div>

                <div className="selected-branch-summary">
                    <div className="branch-summary-item">
                        <span>SELECTED BRANCH</span>
                        <strong style={{ color: displayedBranchColor }}>
                            {displayedBranchName}
                        </strong>
                    </div>

                    <div className="branch-summary-item">
                        <span>ACHIEVED POs</span>
                        <strong>{fmt(branchAchieved)}</strong>
                    </div>

                    <div className="branch-summary-item">
                        <span>MINIMUM TARGET</span>
                        <strong>{fmt(branchMinimum)}</strong>
                    </div>

                    <div className="branch-summary-item">
                        <span>REMAINING POs</span>
                        <strong className="lime">
                            {fmt(branchRemaining)}
                        </strong>
                    </div>

                    <div className="branch-summary-item">
                        <span>AVG. DAILY PACE</span>
                        <strong>
                            {Math.ceil(branchRemaining / WORKING_DAYS)} POs
                        </strong>
                    </div>
                </div>

                {showPlan && (
                    <div className="plan-columns">
                        {renderPlanTable(dailyPlan.slice(0, 11))}
                        {renderPlanTable(dailyPlan.slice(11))}
                    </div>
                )}
            </section>

            <footer className="dashboard-footer">
                <span className="footer-motto">
                    <b>ϟ</b> SMALL WINS. BIG MOMENTUM.
                </span>
                <span className="footer-date">▦ &nbsp; {new Date().toLocaleDateString("en-GB", {
                    weekday: "long",
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                })}</span>
            </footer>
        </main>
    );
}

export default Demo_s;